<template>
    <div class="page-sidebar">
        <span class="logo-box" href="index.html">
            <span>Arcnix控制中心</span>
        </span>
        <div class="page-sidebar-inner">
            <div class="page-sidebar-menu">
                <ul class="accordion-menu">
                    <li class="active-page">
                        <router-link to="/">

                            <i class="menu-icon icon-home4"></i><span>控制台</span>
                        </router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-flash_on"></i><span>Arcnix NEWS</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">

                            <li><router-link to="/news/newstype">News类别</router-link></li>
                            <li><router-link to="/news/newslist">News内容</router-link></li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-layers"></i><span>会员服务</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><router-link to="/os/ostype">服务类别</router-link></li>
                            <li><router-link to="/os/osourcelist">服务内容</router-link></li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-code"></i><span>工单支持</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><router-link to="/order/ordertype">工单类别</router-link></li>
                            <li><router-link to="/order/orderlist">工单内容</router-link></li>
                            <li><router-link to="/order/userorderlist">工单审核</router-link></li>
                            <li><a href="form-image-crop.html">工单统计</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="fa fa-handshake-o" style="margin-right: 11px;font-size:12px;"></i><span>帮助支持</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><router-link to="/help/helptype">帮助类别</router-link></li>
                            <li><router-link to="/help/helplist">帮助内容</router-link></li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-format_list_bulleted"></i><span>其他内容</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><a href="table-static.html">帮助支持</a></li>
                            <li><a href="table-responsive.html">历史更新</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="charts.html">
                            <i class="menu-icon icon-show_chart"></i><span>项目管理</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-my_location"></i><span>用户管理</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><a href="maps-google.html">注册用户管理</a></li>
                            <li><a href="maps-vector.html">Token管理</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <i class="menu-icon icon-star"></i><span>系统管理</span><i
                                class="accordion-icon fa fa-angle-left"></i>
                        </a>
                        <ul class="sub-menu">
                            <li><a href="invoice.html">全站邮件</a></li>
                            <li><a href="invoice.html">系统通知</a></li>
                            <li><a href="invoice.html">用户日志</a></li>
                            <li><a href="invoice.html">系统日志</a></li>

                        </ul>
                    </li>
                    <li class="menu-divider"></li>
                    <li>
                        <a href="index.html">
                            <i class="menu-icon icon-help_outline"></i><span>文档</span>
                        </a>
                    </li>
                    <li><router-link to="/ud-logs" style="clear:both">
                            <i class="menu-icon icon-public"></i><span>内部更新日志</span><span
                                class="label label-danger">1.0</span></router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>